import { useSessionStorage } from '@vueuse/core'
import { AI_QUESTION_BUFFER } from '~/constants'

type AiEndPoint = (l: string[]) => void

export class AIController {
  /** waiting time before sending msgs to ai */
  static INTERVAL = 3 * 1000
  questionList: Ref<string[]>
  timer?: number
  pausedTimer?: number
  aiEndPoint: AiEndPoint

  constructor(aiEndPoint: AiEndPoint) {
    this.aiEndPoint = aiEndPoint
    this.questionList = useSessionStorage(AI_QUESTION_BUFFER, [], { flush: 'sync' })
    if (this.questionList.value.length)
      this.send()
  }

  collect(question: string) {
    this.questionList.value.push(question)
    if (!this.timer)
      this.setTimer()
  }

  async send() {
    const payload = this.questionList.value
    this.questionList.value = []
    if (payload.length > 0)
      await this.aiEndPoint(payload)
  }

  delay() {
    if (this.timer) {
      window.clearTimeout(this.timer)
      this.setTimer()
    }
  }

  pause() {
    if (this.timer) {
      this.pausedTimer = this.timer
      window.clearTimeout(this.timer)
      this.timer = undefined
    }
  }

  resume() {
    if (this.pausedTimer) {
      this.pausedTimer = undefined
      this.setTimer()
    }
  }

  setTimer() {
    this.timer = window.setTimeout(() => {
      this.timer = undefined
      this.send()
    }, AIController.INTERVAL)
  }
}

export function isAICannotResolve(s = '') {
  return /人工|客服|技术支持|客户经理|技术人员|联系/.test(s)
}
